import { sessaoFetchLoading } from '@/service/fetch'
import { serialize } from '@/service/util'

export async function get (id) {
  return sessaoFetchLoading(`base`, `/link/${id}`)
}
export async function getLinks (dados) {
  return sessaoFetchLoading(`base`, `/contrato?` + serialize(dados), 'GET')
}
export async function add (dados) {
  return sessaoFetchLoading(`base`, `/link`, 'POST', dados)
}
export async function edit (dados) {
  return sessaoFetchLoading(`base`, `/link/${dados.id}`, 'PUT', dados)
}
export async function delLink (dados) {
  return sessaoFetchLoading(`base`, `/link/${dados}`, 'DELETE')
}



// WEBPACK FOOTER //
// ./src/api/link.js